import { render, staticRenderFns } from "./SchemaEditRow.vue?vue&type=template&id=3f3e8d08"
import script from "./SchemaEditRow.vue?vue&type=script&lang=ts"
export * from "./SchemaEditRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports